import { useState, useEffect } from "react";
import fullLogo from "../assets/SWPLogo.png"; // Assuming this is the correct path to your logo
import { supabase } from "../supabaseClient"; // Assuming this is where you have the Supabase client

export default function Purchase() {
  const [userId, setUserId] = useState(null); // State for the user ID

  useEffect(() => {
    // Fetch user ID from Supabase session
    const fetchUserId = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        setUserId(session.user.id); // Set userId to the state
      }
    };

    fetchUserId();
  }, []);

  return (
    <>
      <main className="web-view" style={{ textAlign: "center", padding: "2rem" }}>
        <img style={{ marginTop: "2rem" }} src={fullLogo} className='trial-logo' alt="SWP logo"/>
        <h1 style={{ marginTop: "1rem" }}>Purchase SWP Subscription</h1>
        <p style={{ marginTop: "1rem" }}>Only direct billing options are available at this time</p>
        <p>
            Please contact{' '}
            <a className='sub-mail-link' href="mailto:info@lassosafe.com">info@lassosafe.com</a> for more information on how to purchase a subscription.
        </p>
        <button style={{ marginTop: "0.5rem" }} onClick={() => window.location.href = "/"} className="btn-primary">
            Reutrn to the SWP
        </button>      
      </main>
    </>
  );
}
